<template>
  <div class="biasfx2">
    <ModalVideoBiliBili
      v-if="showModal"
      :id="showModalId"
      @close="closeModal"
    />
    <ModalBuy v-show="showModalBuy" />
    <Banner :with-bias-banner="true" />
    <div style="position: relative;">
      <BiasMiniGuitarBanner />
    </div>
    <div
      id="section_00"
      class="heroArea bias-fx2-hero mini-guitar-hero row"
      :style="{backgroundPosition: 'top 100px center', height: '500px', backgroundImage: `url(${require(`@/assets/bias-mini-guitar/sound-hero@2x.png`)})`}"
    />
    <section class="sound">
      <div class="tone-intro">
        <div class="main-img main-imgMiniguitar" />
        <div class="intro-word textCenter row">
          <div class="col-xs-12 col-sm-10 col-sm-offset-1">
            <iframe
              width="100%"
              height="500"
              scrolling="no"
              frameborder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/504209724&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            />
          </div>
        </div>
      </div>
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasMiniGuitarBanner from '@/components/bias-mini-guitar-banner'
import Banner from '@/components/banner'

import ModalVideoBiliBili from '@/components/modal-video-bilibili'
import ModalBuy from '@/components/modal-buy'

import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import SoftwareImageLite from '@/assets/fx-software/image-lite@2x.png'
import SoftwareImageStandard from '@/assets/fx-software/image-standard@2x.png'
import SoftwareImagePro from '@/assets/fx-software/image-pro@2x.png'

import ExpansionImageAcoustic from '@/assets/expansion/image-acoustic-pack@2x.png'
import ExpansionImageBass from '@/assets/expansion/image-bass-pack@2x.png'
import ExpansionImageMetal from '@/assets/expansion/image-metal-pack@2x.png'

import { mapState, mapActions, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'Index',
  store,
  components: {
    Banner,
    ModalVideoBiliBili,
    FooterWeixin,
    FooterCommon,
    BiasMiniGuitarBanner,
    ModalBuy
  },
  data () {
    return {
      showModal: false,
      showModalId: null,
      SoftwareImageLite,
      SoftwareImageStandard,
      SoftwareImagePro,
      ExpansionImageAcoustic,
      ExpansionImageBass,
      ExpansionImageMetal
    }
  },
  computed: {
    ...mapGetters('Auth', {
      isLoginValid: 'isLoginValid'
    }),
    ...mapState('Auth', {
      token: 'token'
    }),
    ...mapState('ModalBuy', {
      showModalBuy: 'show'
    }),
    ...mapState('Software', {
      ownedLicense: 'ownedLicense'
    }),
    ...mapGetters('Software', {
      activeLicenseTier: 'getActiveLicenseTier'
    })
  },
  mounted: function () {
    if (this.isLoginValid) {
      this.getOwnedLicense({ token: this.token, product: 'fx2' })
    }
  },

  methods: {
    ...mapActions('Software', {
      getOwnedLicense: 'getOwnedLicense'
    }),
    openModal (url) {
      this.showModal = true
      this.showModalId = url
    },
    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/pages/bias-fx2.scss";
@import "../styles/pages/bias-mini-guitar.scss";
</style>



// WEBPACK FOOTER //
// src/pages/bias-mini-guitar-sound.vue